module.exports = __webpack_public_path__ + "static/img/qudi (9).5617635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (9).jpg
// module id = U7Gu
// module chunks = 0